import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { useDataLayerValue } from "../../DataLayer/DataLayer";
import Layout from "../../Layout";
import HeaderBread from "../../components/HeaderBread";
import CustomHeaderTitle from "../../components/constants/CustomHeaderTitle";
import AgeValidationInput from "../../components/AgeValidationInput";
import { getAgeValidationById } from "../../utils/ApiCalls/AgeValidation";

const EditAgeValidation = () => {
  const params = useParams();
  const [ageValidation, setAgeValidation] = useState({});
  const [, dispatch] = useDataLayerValue();
  const navigation = [
    {
      title: "Home",
      route: "/",
    },
    {
      title: "Age Validation",
      route: "/shore/mobile-masters/age-validation",
    },
    {
      title: "Edit Age Validation",
      route: "/shore/mobile-masters/age-validation/edit",
    },
  ];

  useEffect(() => {
    getData(params?.id);
  }, [params]);

  const getData = async (id) => {
    dispatch({ type: "SET_LOADING", loading: true });
    const data = await getAgeValidationById(id);
    if (data.error) {
      dispatch({
        type: "SET_ERROR_MESSAGE",
        errMess: { message: data.error, type: "error" },
      });
    } else {
      setAgeValidation(data);
    }
    dispatch({ type: "SET_LOADING", loading: false });
  };

  return (
    <Layout type={"update_per"} module_data={"Age Validation"}>
      <CustomHeaderTitle title={"Edit Age Validation"} />
      <HeaderBread
        navigation={navigation}
        title={"Edit Age Validation"}
      ></HeaderBread>
      {ageValidation?.isDeleted === 0 && (
        <div className="container-fluid">
          <div className="alert alert-secondary" role="alert">
            This record has been removed - showing a read-only view.
          </div>
        </div>
      )}
      {ageValidation && (
        <AgeValidationInput
          ageValidation={ageValidation}
          readOnly={ageValidation?.isDeleted === 0}
        />
      )}
    </Layout>
  );
};

export default EditAgeValidation;
